var map = {
	"./adminprofile/add": [
		1934,
		15
	],
	"./agentprofile/add": [
		1935,
		18
	],
	"./ai_assistant/add": [
		1936,
		21
	],
	"./api_key/add": [
		1937,
		24
	],
	"./canned_answer/add": [
		1938,
		29
	],
	"./client/add": [
		1939,
		32
	],
	"./disposition/add": [
		1940,
		37
	],
	"./field/add": [
		1941,
		40
	],
	"./form/add": [
		1942,
		43
	],
	"./form_website/add": [
		1943,
		46
	],
	"./invoice_post/add": [
		1944,
		53
	],
	"./journey/add": [
		1945,
		56
	],
	"./journey_draft/add": [
		1946,
		59
	],
	"./journey_variable/add": [
		1947,
		63
	],
	"./list/add": [
		1948,
		66
	],
	"./list_file/add": [
		1949,
		69
	],
	"./mail_account/add": [
		1950,
		72
	],
	"./operational_hours/add": [
		1951,
		75
	],
	"./organization/add": [
		1952,
		78
	],
	"./pause/add": [
		1953,
		81
	],
	"./phonenumber_monthly_cost/add": [
		1954,
		84
	],
	"./phonenumber_monthly_cost_parent/add": [
		1955,
		87
	],
	"./phonenumber_purchase/add": [
		1956,
		91
	],
	"./phonenumber_setup_cost/add": [
		1957,
		94
	],
	"./phonenumber_setup_cost_parent/add": [
		1958,
		97
	],
	"./prepaid_credit/add": [
		1959,
		104
	],
	"./queue/add": [
		1960,
		107
	],
	"./signature/add": [
		1961,
		111
	],
	"./skill/add": [
		1962,
		114
	],
	"./sla_policy/add": [
		1963,
		117
	],
	"./sound/add": [
		1964,
		120
	],
	"./stats_alarm/add": [
		1965,
		123
	],
	"./stats_custom_metric/add": [
		1966,
		126
	],
	"./stats_report/add": [
		1967,
		129
	],
	"./stats_widget/add": [
		1968,
		132
	],
	"./superadmin_profile/add": [
		1969,
		135
	],
	"./tag/add": [
		1970,
		138
	],
	"./tariff/add": [
		1971,
		141
	],
	"./tariff_parent/add": [
		1972,
		144
	],
	"./team/add": [
		1973,
		147
	],
	"./text_message_source/add": [
		1974,
		9
	],
	"./time_interval/add": [
		1975,
		151
	],
	"./user/add": [
		1976,
		154
	],
	"./voice_asterisk/add": [
		1977,
		157
	],
	"./voice_asterisk_downgrade/add": [
		1978,
		160
	],
	"./voice_route/add": [
		1979,
		167
	],
	"./voice_shortcut/add": [
		1980,
		170
	],
	"./voice_trunk/add": [
		1981,
		173
	],
	"./voice_voicemail/add": [
		1982,
		176
	],
	"./wallboard/add": [
		1983,
		179
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 1857;
module.exports = webpackAsyncContext;